import * as $gzHpId from './hpid.service';

export default angular.module('gazelle.components.hpid', [
  'ui.router',
  'rhino.core',
  'rhino.components.locale',
])
  .factory($gzHpId.name, $gzHpId.default)
  .name;
